import React, { useCallback } from "react";
import * as THREE from 'three';
import MLeg from '../marker/mLeg';

import { Lines } from "../shape/Line";
import MBound from '../marker/MBound';

import MPoints2DAdd from '../marker/mPoints2DAdd';
import MPoints2DDel from '../marker/mPoints2DDel';
import MPoints3D from '../marker/mPoints3D';
import { MModify } from '../marker/mModify';
import { MTrim } from '../marker/mTrim';
import { MThick } from '../marker/mThick';

import MBox from '../marker/mBox';
import MSocket from '../marker/mSocket';
import MMeasure from '../marker/mMeasure';

import { CrossSectionsBk, CrossSectionsBkMeshBased, CrossSectionText } from '../marker/mCrossSection';

import { GetBounds } from '../shape/Compress';
import { GetTrim2D } from '../shape/Trim';
import { getShapePTB, getShapeCounter, getShapeTibia, getShapeFibulaLeft, getShapeFibulaRight, getShapeUser } from '../shape/Modify';
import Control from '../store/control';
import Param from '../store/param';
import MOutputBkFd from "../marker/mOutputBkFd";

// -----------------------------------------------
// （本義足/テストソケット）共通のマーカー制御を行う
// Paramへのアクセスはここに集約し、marker/ 配下では行わないこと！
// -----------------------------------------------

const MarkingCommon = () => {
  const activeStep         = Param.Get("activeStep");
  const setup              = Param.Get("setup");
  const align              = Param.Get("align");
  const marking            = Param.Get("marking");
  const compress           = Param.Get("compress");
  const modify             = Param.Get("modify");
  const trim               = Param.Get("trim");
  const thick              = Param.Get("thick");
  const outputBk           = Param.Get("outputBk");
  const joint              = Param.Get("joint");
  const assemble           = Param.Get("assemble");
  const reinforth          = Param.Get("reinforth");
  const connection         = Param.Get("connection");
  const setParam           = Param.Get("setParam");
  const setModifyPoints    = Param.Get("setModifyPoints");
  const setModifyPointsI   = Param.Get("setModifyPointsI");
  const setModifyPointsO   = Param.Get("setModifyPointsO");
  //const debug              = Param.Get("debug");
  
  const setControl         = Control.Get("setControl");
  const showLeg            = Control.Get("showLeg");
  const showSocket         = Control.Get("showSocket");
  const showMirror         = Control.Get("showMirror");
  const wireLeg            = Control.Get("wireLeg");
  const transparentLeg     = Control.Get("transparentLeg");
  const wireSocket         = Control.Get("wireSocket");
  const meshLeg            = Control.Get("meshLeg");
  const meshSocketCompress = Control.Get("meshSocketCompress");
  const meshSocketModify   = Control.Get("meshSocketModify");
  const meshSocketTrim     = Control.Get("meshSocketTrim");
  const meshSocketThick    = Control.Get("meshSocketThick");
  const meshSocketOutput   = Control.Get("meshSocketOutput");
  const meshSocketJoint    = Control.Get("meshSocketJoint");

  const redrawBox          = Control.Get("redrawBox");
  const flgLegClickable    = Control.Get("flgLegClickable");
  const flgSocketClickable = Control.Get("flgSocketClickable");
  const currentAngle       = Control.Get("currentAngle");
  const showBound          = Control.Get("showBound");
  const showLine           = Control.Get("showLine");
  const pointCross         = Control.Get("pointCross");
  const oriPointCross      = Control.Get("oriPointCross");
  const pointMerdian       = Control.Get("pointMerdian");
  const measure            = Control.Get('measure');
  const applyModify        = Control.Get('applyModify');
  const bottomPoints       = Control.Get('bottomPoints');
  const upperEdgePoints    = Control.Get('upperEdgePoints');
  const lowerEdgePoints    = Control.Get('lowerEdgePoints');
  const outerUpperEdgePoints = Control.Get('outerUpperEdgePoints');
  
  var meshSocketShow = null;
  const opacity = showLeg ? 0.5 : 0.8;
  const opacityLeg = (activeStep>=6) ? 0.5 : 1;

  switch (activeStep){
    case 3:  // Modify
      meshSocketShow = (meshSocketModify) && (modify.step >= 1) ? meshSocketModify : meshLeg;
      break;
    case 4:  // compress
      // meshSocketShow = meshSocketCompress;
      meshSocketShow = (compress.step >= 2) ? meshSocketCompress : meshSocketModify;

      // // project meshLeg color to loftSurface
      // if (meshSocketShow) {
      //   // project meshLeg color to loftSurface
      //   const sourceVertices = meshLeg.geometry.attributes.position.array;
      //   const sourceColors = meshLeg.geometry.attributes.color.array;
      //   const targetVertices = meshSocketShow.geometry.attributes.position.array;

      //   const targetColors = new Float32Array(targetVertices.length);

      //   for (let i = 0; i < targetVertices.length; i += 3) {
      //     let minDistance = Infinity;
      //     let closestColor = null;

      //     const tx = targetVertices[i];
      //     const ty = targetVertices[i + 1];
      //     const tz = targetVertices[i + 2];

      //     for (let j = 0; j < sourceVertices.length; j += 3) {
      //       const sx = sourceVertices[j];
      //       const sy = sourceVertices[j + 1];
      //       const sz = sourceVertices[j + 2];

      //       const distance = Math.sqrt((tx - sx) ** 2 + (ty - sy) ** 2 + (tz - sz) ** 2);

      //       if (distance < minDistance) {
      //         minDistance = distance;
      //         closestColor = [sourceColors[j], sourceColors[j + 1], sourceColors[j + 2]];
      //       }
      //     }

      //     if (closestColor !== null) {
      //       targetColors[i] = closestColor[0];
      //       targetColors[i + 1] = closestColor[1];
      //       targetColors[i + 2] = closestColor[2];
      //     }
      //   }

      //   meshSocketShow.geometry.setAttribute('color', new THREE.Float32BufferAttribute(targetColors, 3));
      // }

      break;
    case 5:  // Trim
      meshSocketShow = (trim.step < 2) ? meshSocketCompress : meshSocketTrim; // trim.step 0:before apply 1:after apply
      break;
    case 6:  // Thick
      meshSocketShow = meshSocketThick;
      break;
    case 7:  // Output
      meshSocketShow = (outputBk.step == 0) ? meshSocketThick : meshSocketOutput;
      break;
  }

  const isMeasure   = measure;
  const isLeg       = meshLeg && showLeg;
  const isSocket    = showSocket && (activeStep >= 3); // meshSocketCompress && showSocket && (activeStep >= 3);
  const isModify    = (activeStep == 3);
  const isModifyLocal = (activeStep == 3) && (process.env.REACT_APP_CALC_MODE==0) && (applyModify);
  const isComp      = (activeStep == 4);
  const isCrossCurve      = isComp; // && showLine
  const isCrossCurveLocal = isComp && (process.env.REACT_APP_CALC_MODE==0); // && showLine
  const isBound     = isComp && showBound;
  const isTrim2DAdd = (activeStep == 5) && (trim.step == 0) && (trim.mode == 0); // trim.step: 0(2D), 1(3D)
  const isTrim2DDel = (activeStep == 5) && (trim.step == 0) && (trim.mode == 1); // trim.mode: 0(Move/Create Point), 1:(Delete)
  const isTrim3D    = (activeStep == 5) && (trim.step >= 1);
  const isTrimLocal = (activeStep == 5) && (trim.step == 2) && (process.env.REACT_APP_CALC_MODE==0);
  const isThickLocal = (activeStep == 6) && (process.env.REACT_APP_CALC_MODE==0);
  const isOutput   = (activeStep == 7);

  // for marking
  var meshSocket = null;
  if (meshSocketCompress && process.env.REACT_APP_CALC_MODE==1) {
    const geometry = new THREE.BufferGeometry();
    const material = new THREE.MeshLambertMaterial();
    geometry.setFromPoints(meshSocketCompress.vertices);
    geometry.setIndex(meshSocketCompress.faces)
    geometry.rotateX(-Math.PI / 2,0,0)
    meshSocket = new THREE.Mesh(geometry, material);
    //meshSocket.rotation.x = -Math.PI / 2,0,0
  } else {
    meshSocket = meshSocketCompress;
  }

  if (meshSocketJoint && process.env.REACT_APP_CALC_MODE==1) {
    const geometry = new THREE.BufferGeometry();
    const material = new THREE.MeshLambertMaterial();
    geometry.setFromPoints(meshSocketCompress.vertices);
    geometry.setIndex(meshSocketCompress.faces)
    geometry.rotateX(-Math.PI / 2,0,0)
    meshSocket = new THREE.Mesh(geometry, material);
    //meshSocket.rotation.x = -Math.PI / 2,0,0
  }

  if (isBound) {
    var bounds = GetBounds(meshLeg, compress.interval, compress.extention, compress.line_count, compress.offset, compress.compression);
  }

  // save aligned mesh to export at final step
  if (activeStep == 2) { // marking step
    // deepCopy
    let leg = meshLeg.clone()
    let geometry = leg.geometry.clone()
    let material = leg.material.clone()
    const alignedMeshLeg = new THREE.Mesh(geometry, material);
    setControl(s => {s.alignedMeshLeg = alignedMeshLeg});
  }

  // For PTB, we will modify the shape as z direction, but for other area, we will modify the shape as normal direction.
  const normalModify = (Number(modify.target)==0) ? false : true;

  if (isModify) {
    var vptI = [];
    var vptO = [];
    const target = Number(modify.target);

    for (let i = 0; i < modify.depth.length; i++) {
      if (modify.vptI[i] == null) { // initialize modify points
        switch (i) {
          case 0: // PTB
            if (marking.vpt[0] && marking.vpt[1]) {
              if(setup.side == 0) { // left
                [vptI, vptO] = getShapePTB(meshLeg, marking.vpt[0], marking.vpt[1], align.vpt_ptbI, align.vpt_ptbO);
              } else if(setup.side == 1) { // right
                [vptI, vptO] = getShapePTB(meshLeg, marking.vpt[0], marking.vpt[1], align.vpt_ptbO, align.vpt_ptbI);
              }
            }
            break;
          case 1: // Counter
            if (marking.vpt[0] && marking.vpt[1]) {
              // [vptI, vptO] = getShapeCounter(meshSocket, marking.vpt[0], marking.vpt[1]);
              [vptI, vptO] = getShapeCounter(meshLeg, marking.vpt[0], marking.vpt[1]);
            }
            break;
          case 2: // Tibia
            if (marking.vpt[0] && marking.vpt[1] && marking.vpt[2]) {
              [vptI, vptO] = getShapeTibia(meshLeg, marking.vpt[0], marking.vpt[1], marking.vpt[2], setup.side);
            }
            break;
          case 3: // Head of Fibura
            if (marking.vpt[3]) {
              if(setup.side == 1) { // right
                var vpt = new THREE.Vector2(marking.vpt[3].y, marking.vpt[3].z);
                // [vptI, vptO] = getShapeFibulaLeft(meshSocket, vpt);
                [vptI, vptO] = getShapeFibulaLeft(meshLeg, vpt);
              }
              else if (setup.side == 0) { // left
                //var vpt = new THREE.Vector2(-marking.vpt[3].y, marking.vpt[3].z);
                var vpt = new THREE.Vector2(marking.vpt[3].y, marking.vpt[3].z);
                // [vptI, vptO] = getShapeFibulaRight(meshSocket, vpt);
                [vptI, vptO] = getShapeFibulaRight(meshLeg, vpt);
              }
            }
            break;
          case 4: // End of Fibura
            if (marking.vpt[4]) {
              if (setup.side == 1) { // right
                var vpt = new THREE.Vector2(marking.vpt[4].y, marking.vpt[4].z);
                // [vptI, vptO] = getShapeFibulaLeft(meshSocket, vpt);
                [vptI, vptO] = getShapeFibulaLeft(meshLeg, vpt);
              }
              else if (setup.side == 0) { // left
                var vpt = new THREE.Vector2(marking.vpt[4].y, marking.vpt[4].z);
                // [vptI, vptO] = getShapeFibulaRight(meshSocket, vpt);
                [vptI, vptO] = getShapeFibulaRight(meshLeg, vpt);
              }
            }
            break;
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
            if (marking.vpt[i]) {
              // [vptI, vptO] = getShapeUser(meshSocket, marking.vpt[target], marking.angle[target]);
              [vptI, vptO] = getShapeUser(meshLeg, marking.vpt[i], marking.angle[i]);
            }
            break;
        }
        setModifyPoints(i, vptI, vptO);
      } else { // modify points are already set
        if (modify.vptI[modify.target]) vptI = modify.vptI[modify.target];
        if (modify.vptO[modify.target]) vptO = modify.vptO[modify.target];
      }
    }
  }

  if (isTrim2DAdd || isTrim2DDel) {
    var ptTrim2D = GetTrim2D(meshSocket);
  }

  if (isTrim3D && trim.vpt3D) {
    var ptTrim3D = [];
    trim.vpt3D.forEach((v) => {
      ptTrim3D.push(v);
    });
  }

  if (showMirror == 1 && thick.mlConnector) {
    thick.mlConnector *= -1;
  }


  // Callback /////////////////////////////////////////////
  const callSaveLegCenter = useCallback((center) => {
    setParam(s => {s.align.legCenter = center});
  }, []);
  const callSaveLegRotation = useCallback((angle) => {
    setParam(s => {s.align.rotationX = angle[0]});
    setParam(s => {s.align.rotationY = angle[1]});
    setParam(s => {s.align.rotationZ = angle[2]});
  }, []);
  const callContourPoints = useCallback((oriPoints, points) => {
    setParam(s => {s.compress.line_count = points.length});
    setControl(s => {s.pointCross = points});
    setControl(s => {s.oriPointCross= oriPoints});
  }, []);
  const callContourMdeianPoints = useCallback((points) => {
    setControl(s => {s.pointMerdian = points});
  }, []);
  const callMeshSocketCompress = useCallback((mesh) => {
    setControl(s => {s.meshSocketCompress = mesh});
  }, []);
  const callBottomPoints = useCallback((points) => {
    setControl(s => {s.bottomPoints = points});
  }, []);
  const callCompressStep = useCallback((v) => {
    setParam(s => {s.compress.step = v});
  }, []);

  const callMeshSocketTrim = useCallback((mesh) => {
    setControl(s => {s.meshSocketTrim = mesh})
    //setControl(s => {s.meshSocketModify = mesh})
  }, []);
  const callUpperEdge = useCallback((points) => {
    setControl(s => {s.upperEdgePoints = points})
  }, []);
  const callLowerEdge = useCallback((points) => {
    setControl(s => {s.lowerEdgePoints = points})
  }, []);

  const callMeshSocketModify = useCallback((mesh) => {
    setControl(s => {s.applyModify = false});
    setControl(s => {s.meshSocketModify = mesh})
  }, []);

  const callMeshSocketThick = useCallback((mesh) => {
    setControl(s => {s.meshSocketThick = mesh})
  }, []);

  const callMeshSocketOutput = useCallback((mesh) => {
    setControl(s => {s.meshSocketOutput = mesh})
  }, []);

  const callMaxBoundaryCurveIndex = useCallback((value) => {
    setParam(s => {s.thick.maxBoundaryCurveIndex = value})
  }, []);

  const callOuterUpperEdgePoints = useCallback((points) => {
    // deepcopy to avoid infinite loop
    var pointsNew = points.map((v) => {
      return new THREE.Vector3(v.x, v.y, v.z);
    });
    setControl(s => {s.outerUpperEdgePoints = pointsNew})
  }, []);
  

  const callSaveModifyI = (vpoints) => {
    // deepcopy
    const newPoints = vpoints.map((v) => {
      return new THREE.Vector3(v.x, v.y, v.z);
    });
    console.log('callback target', Number(modify.target), vpoints[0])
    setModifyPointsI(modify.target, newPoints);
  };

  const callSaveModifyO = (vpoints) => {
    // deepcopy
    const newPoints = vpoints.map((v) => {
      return new THREE.Vector3(v.x, v.y, v.z);
    });
    setModifyPointsO(Number(modify.target), newPoints);
  };

  const callSave2D = useCallback((points) => {
    setParam(s => {s.trim.vpt2D = points});
  }, []);
  
  const callSave3D = useCallback((points) => {
    setParam(s => {s.trim.vpt3D = points});
  }, []);



  return (
    <>
      { isMeasure  ? <MMeasure
                      angle = {currentAngle}
                      color={'dodgerblue'}
                      colorHigh={'deeppink'}
                      colorSub={'orange'}
                      /> : null }

      { isLeg     ? <MLeg 
                      meshLeg={meshLeg} 
                      clickable={flgLegClickable} 
                      showWire={wireLeg}
                      showTransparent={transparentLeg}
                      side={0} // for BK, we don't need to show mirror
                      loadParam={setup.loadParam}
                      mirror={showMirror}
                      modifyBackWall={marking.modifyBackWall}
                      opacityLeg={opacityLeg}
                      fileExt={0}
                      callback0={callSaveLegCenter}
                      callback1={callSaveLegRotation}
                    /> : null }

      { meshLeg && (activeStep == 1) ? <MBox 
                      mesh={meshLeg} 
                      color={"cyan"}
                      redrawBox={redrawBox}
                    /> : null }

      { isSocket  ? <MSocket
                      meshSocket={meshSocketShow} 
                      clickable={flgSocketClickable} 
                      opacity={opacity}
                      executeSmooth={modify.executeSmooth}
                      iterationSmooth={modify.iterationSmooth}
                      color={'dodgerblue'}
                      colorHigh={'deeppink'}
                      colorSub={'orange'}
                    /> : null }

      {/*
      { isBound   ? <MBound
                      color={"orange"}
                      colorHigh={"yellow"}
                      no={comp.line_no}
                      bounds={bounds}
                    /> : null }
      */}


      {/* for offline calculation */}
      { isCrossCurveLocal ? <CrossSectionsBk
                      oriMeshLeg={meshLeg}
                      oriMeshSocket={meshSocketModify}
                      compressionWhole={compress.compressionWhole}
                      compression={compress.compression}
                      no={compress.line_no}
                      interval={compress.interval}
                      smoothness={compress.smoothness}
                      bottomExtension={compress.bottomExtension}
                      step={compress.step}

                      callback0 = {callContourPoints}
                      callback1 = {callContourMdeianPoints}
                      callback2 = {callMeshSocketCompress}
                      callback3 = {callBottomPoints}
                      callback4 = {callCompressStep}
                      color={'dodgerblue'}
                      colorHigh={'deeppink'}
                      colorSub={'orange'}
                    /> : null }
      
            {/* { isCrossCurveLocal ? <CrossSectionsBkMeshBased
                      oriMeshLeg={meshLeg}
                      oriMeshSocket={meshSocketModify}
                      compressionWhole={compress.compressionWhole}
                      compression={compress.compression}
                      no={compress.line_no}
                      interval={compress.interval}
                      smoothness={compress.smoothness}
                      bottomExtension={compress.bottomExtension}
                      step={compress.step}

                      callback0 = {callContourPoints}
                      callback1 = {callContourMdeianPoints}
                      callback2 = {callMeshSocketCompress}
                      callback3 = {callBottomPoints}
                      callback4 = {callCompressStep}
                      color={'dodgerblue'}
                      colorHigh={'deeppink'}
                      colorSub={'orange'}
                    /> : null } */}
      
      { (isCrossCurve && pointCross && oriPointCross)  ? <CrossSectionText
                      oriMeshLeg={meshLeg}
                      oriContourPointsAll={oriPointCross}
                      contourPointsAll={pointCross}
                      compression={compress.compression}

                      color={'dodgerblue'}
                      colorHigh={'deeppink'}
                      colorSub={'orange'}
                 />: null }
      
      {/* cross section curve */}
      { isCrossCurve ? <Lines 
                      vlines={pointCross}
                      color={"cyan"}
                      colorHigh={"deeppink"}
                      no={compress.line_no}
                    /> : null }

      {/* merdian curve */}
      { isCrossCurve ? <Lines
                      vlines={pointMerdian}
                      color={"cyan"}
                      colorHigh={"deeppink"}
                      no={-1}
                    /> : null }

      {/* for offline modify calculation */}
      { isModifyLocal ? <MModify
                      // oriMeshSocket={meshSocketTrim}
                      oriMeshSocket={meshLeg}
                      // pointsI={vptI}
                      // pointsO={vptO}
                      // depth={modify.depthNow[modify.target]}
                      pointsIs={modify.vptI}
                      pointsOs={modify.vptO}
                      depths={modify.depthNow}
                      smooths={modify.smooth}
                      normal={normalModify}
                      color={'dodgerblue'}
                      colorHigh={'deeppink'}
                      colorSub={'orange'}
                      callback={callMeshSocketModify}
                    /> : null }

      { isModify && vptI  ? 
                    <MPoints3D
                      vpoints={vptI} 
                      colorSpline={"red"} 
                      colorDrag={"red"}
                      colorDisable={"darkred"}
                      colorClick={"pink"} 
                      // mesh={meshSocket}
                      mesh={meshLeg} 
                      mode={modify.mode}
                      angle={currentAngle}
                      callback={callSaveModifyI}
                    /> : null }

      { isModify && vptO  ? 
                    <MPoints3D
                      vpoints={vptO} 
                      colorSpline={"orange"} 
                      colorDrag={"orange"}
                      colorDisable={"darkorange"}
                      colorClick={"pink"} 
                      // mesh={meshSocket}
                      mesh={meshLeg} 
                      mode={modify.mode}
                      angle={currentAngle}
                      callback={callSaveModifyO}
                    /> : null }

      { isTrim2DAdd  ? <MPoints2DAdd 
                        vpoints={ptTrim2D} 
                        colorLine={"cyan"} 
                        colorDrag={"red"} 
                        colorClick={"pink"}
                        size1={1}
                        size2={0.75}
                        showtype={"2D"} 
                        callback={callSave2D}
                      /> : null }

      { isTrim2DDel  ? <MPoints2DDel 
                        vpoints={ptTrim2D} 
                        colorLine={"cyan"} 
                        colorClick={"blue"}
                        size={1}
                        showtype={"2D"}
                        callback={callSave2D}
                    /> : null }

      { isTrim3D  ? <MPoints3D
                      vpoints={ptTrim3D} 
                      colorSpline={"orange"}
                      colorDrag={"red"}
                      colorDisable={"darkred"}
                      colorClick={"pink"} 
                      mesh={meshSocket} 
                      mode={trim.mode}
                      angle={currentAngle}
                      callback={callSave3D}
                    /> : null }

      {/* for offline trimming calculation */}
      { isTrimLocal ? <MTrim 
                      oriMeshSocket={meshSocketCompress}
                      ptTrim3D={ptTrim3D}
                      bottomPoints={bottomPoints}
                      curveWidth={trim.curveWidth}
                      curveAngle={trim.curveAngle}
                      curveR={trim.curveR}
                      curveSmooth={trim.curveSmooth}
                      curveRange={trim.curveRange}
                      callback0={callMeshSocketTrim}
                      callback1={callUpperEdge}
                      callback2={callLowerEdge}
                      color={'dodgerblue'}
                      colorHigh={'deeppink'}
                      colorSub={'orange'}
                    /> : null }

      {/* for offline thicken calculation */}
      { isThickLocal ? <MThick
                      // oriMeshSocket={meshSocketModify}
                      oriMeshSocket={meshSocketTrim}
                      upperEdgePoints={upperEdgePoints}
                      lowerEdgePoints={lowerEdgePoints}
                      thickness={thick.outerThickness}
                      step={thick.step}
                      flexionAngle={thick.flexionAngle}
                      connector={thick.connector}
                      apConnector={thick.apConnector}
                      mlConnector={thick.mlConnector}
                      boundaryCurveIndex={thick.boundaryCurveIndex}
                      callback0={callMeshSocketThick}
                      callback1={callMaxBoundaryCurveIndex}
                      callback2={callOuterUpperEdgePoints}
                      color={'dodgerblue'}
                      colorHigh={'deeppink'}
                      colorSub={'orange'}
                    /> : null }
      
      { isOutput ? <MOutputBkFd
                      oriMeshSocket={meshSocketThick}
                      oriInnerUpperEdgePoints={upperEdgePoints}
                      oriOuterUpperEdgePoints={outerUpperEdgePoints}
                      thickness={thick.outerThickness}
                      step={outputBk.step}
                      reinforcementTopEdgeThickness={outputBk.reinforcementTopEdgeThickness}
                      reinforcementTopEdgeWidth={outputBk.reinforcementTopEdgeWidth}
                      reinforcementWeaknestAreaThickness={outputBk.reinforcementWeaknestAreaThickness}
                      reinforcementWeaknestAreaWidth={outputBk.reinforcementWeaknestAreaWidth}
                      callback0={callMeshSocketOutput}
                      color={'dodgerblue'}
                      colorHigh={'deeppink'}
                      colorSub={'orange'}
                    /> : null }
    </>
  );
};

export default MarkingCommon;
